module.exports = __webpack_public_path__ + "b629a518.png";